import { render, staticRenderFns } from "./CertificationInfo.vue?vue&type=template&id=19c6590d&scoped=true&"
import script from "./CertificationInfo.vue?vue&type=script&lang=ts&"
export * from "./CertificationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c6590d",
  null
  
)

export default component.exports